import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_ASSESSMENT_LIST,
  GET_VIEW_ASSESSMENT_LIST,
  POST_SELECTED_QUESTION,
  SEARCH_QUESTION_FROM_QUESTION_BANK,
  UPDATE_ACTIVITY_STATUS,
  UPDATE_SELECTED_QUESTION,
} from "./actionTypes";
import {
  changeAssessmentStatusFailed,
  changeAssessmentStatusSuccess,
  getAssesmentListFailed,
  getAssesmentListSuccess,
  postSelectedAssesmentQuestionFailed,
  postSelectedAssesmentQuestionsuccess,
  searchQuestionsFailed,
  searchQuestionssuccess,
  viewAssesmentquestionsFailed,
  viewAssesmentquestionsSuccess,
} from "./actions";

import {
  getassesment,
  postAssesmentQuestions,
  updateAssessmentQuestions,
  updateAssessmentStatus,
} from "../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";

// get JOB list
function* getAssesmentListHandler(data) {
  try {
    let jsondata = data.payload;
    let url = constClass.REST_API_GET_ASSESSMENT_LIST;
    if (
      jsondata?.searchKeyword !== undefined &&
      jsondata?.searchKeyword !== null &&
      jsondata?.searchKeyword !== ""
    ) {
      url =
        url +
        `?keyword=${decodeURIComponent(jsondata?.searchKeyword)}&pageNumber=${jsondata?.pageNumber}&pageSize=${jsondata?.pageSize}`;
    } else {
      if (
        jsondata.active !== undefined &&
        jsondata.active !== null &&
        jsondata.includeId !== undefined &&
        jsondata.includeId !== null
      ) {
        url =
          url +
          `?pageNumber=${jsondata?.pageNumber}&pageSize=${jsondata?.pageSize}&active=${jsondata.active}&includeId=${jsondata.includeId}`;
      } else if (jsondata.active !== undefined && jsondata.active !== null) {
        url =
          url +
          `?pageNumber=${jsondata?.pageNumber}&pageSize=${jsondata?.pageSize}&active=${jsondata.active}`;
      } else {
        url =
          url +
          `?pageNumber=${jsondata?.pageNumber}&pageSize=${jsondata?.pageSize}`;
      }
    }

    let responsJSON = yield call(getassesment, url);
    yield put(getAssesmentListSuccess(responsJSON));
  } catch (error) {
    yield put(getAssesmentListFailed(error));
  }
}

function* getViewQuestionListHandler(data) {
  try {
    let url =
      constClass.REST_API_GET_ASSESSMENT_LIST + `/${data.payload.id}/question`;
    // ?pageNumber=${data.payload.pageNumber}&pageSize=${10}
    let responsJSON = yield call(getassesment, url);
    yield put(viewAssesmentquestionsSuccess(responsJSON));
  } catch (error) {
    yield put(viewAssesmentquestionsFailed(error));
  }
}

function* updateAssesmentStatusHandler(data) {
  try {
    let url = constClass.REST_API_GET_ASSESSMENT_LIST + `/${data.payload.id}`;
    let responsJSON = yield call(updateAssessmentStatus, url, {
      isActive: data.payload.status,
    });
    yield put(changeAssessmentStatusSuccess(responsJSON));
  } catch (error) {
    yield put(changeAssessmentStatusFailed(error));
  }
}

function* searchQuestionsListHandler(data) {
  try {
    let url =
      constClass.REST_API_GET_QUESTIONBANK_LIST +
      `?pageNumber=${data.payload.pageNumber}&pageSize=10`;

    if (
      data.payload.keyWord !== undefined &&
      data.payload.keyWord !== null &&
      data.payload.keyWord !== ""
    ) {
      url = url + `&keyword=${data.payload.keyWord}&type=${data.payload?.type}`;
      if (
        data.payload?.selectedQuestions !== undefined &&
        data.payload?.selectedQuestions !== null &&
        data.payload?.selectedQuestions !== ""
      ) {
        url = url + `&exclude=${data.payload.selectedQuestions}`;
      }
    } else if (
      data.payload.selectedQuestions !== undefined &&
      data.payload.selectedQuestions !== null &&
      data.payload.selectedQuestions !== ""
    ) {
      url =
        url +
        `&type=${data.payload?.type}&exclude=${data.payload.selectedQuestions}`;
    } else if (
      data.payload?.type !== undefined &&
      data.payload?.type !== null &&
      data.payload?.type !== ""
    ) {
      url = url + `&type=${data.payload?.type}`;
    }

    url = url + `&status=true`;

    let responsJSON = yield call(getassesment, decodeURIComponent(url));
    yield put(searchQuestionssuccess(responsJSON));
  } catch (error) {
    yield put(searchQuestionsFailed(error));
  }
}

function* submitSelectedQustionsHandler(data) {
  try {
    let url = constClass.REST_API_GET_ASSESSMENT_LIST;
    let responsJSON = yield call(postAssesmentQuestions, url, data.payload);
    yield put(postSelectedAssesmentQuestionsuccess(responsJSON));
  } catch (error) {
    yield put(postSelectedAssesmentQuestionFailed(error));
  }
}

function* updateSelectedAssessmentQuestionsHandler(data) {
  try {
    let url = constClass.REST_API_GET_ASSESSMENT_LIST + `/${data.payload.id}`;
    let responsJSON = yield call(updateAssessmentQuestions, url, data.payload);
    yield put(postSelectedAssesmentQuestionsuccess(responsJSON));
  } catch (error) {
    yield put(postSelectedAssesmentQuestionFailed(error));
  }
}

function* ManageAssessmentSaga() {
  yield takeLatest(GET_ASSESSMENT_LIST, getAssesmentListHandler);
  yield takeEvery(
    SEARCH_QUESTION_FROM_QUESTION_BANK,
    searchQuestionsListHandler,
  );
  yield takeEvery(UPDATE_ACTIVITY_STATUS, updateAssesmentStatusHandler);
  yield takeEvery(GET_VIEW_ASSESSMENT_LIST, getViewQuestionListHandler);
  yield takeEvery(POST_SELECTED_QUESTION, submitSelectedQustionsHandler);
  yield takeEvery(
    UPDATE_SELECTED_QUESTION,
    updateSelectedAssessmentQuestionsHandler,
  );
}

export default ManageAssessmentSaga;
